<div #opAirlineSelectorRootEle class="op-airline-selector">
  <p-select
    [ngModel]="airlineModel()"
    [options]="airlines()"
    optionLabel="name"
    optionValue="id"
    [filter]="true"
    filterBy="name,code"
    (onChange)="change($event)"
    [virtualScroll]="true"
    [virtualScrollItemSize]="38"
    [overlayOptions]="{ mode: 'overlay', styleClass: 'op-airline-selector-overlay' }"
    [appendTo]="opAirlineSelectorRootEle"
    [fluid]="false">
    <ng-template pTemplate="selectedItem" let-data>
      <div class="op-airline-selector-value-template uk-flex uk-flex-middle">
        @if(data) {
          <span>
            <img [src]="data?.favico_url" opOnErrorSrc="assets/img/plane2.jpg" />
            <div class="airline-code">{{ data?.code }}</div>
          </span>
          <span>{{ data?.name }}</span>
          }
      </div>
    </ng-template>
    <ng-template pTemplate="item" let-data>
      <div class="op-airline-selector-item-template uk-flex uk-flex-middle">
        <div>
          <img [src]="data?.favico_url" opOnErrorSrc="assets/img/plane2.jpg" />
        </div>
        <span class="airline-code-badge">{{ data?.code }}</span>
        <span>{{ data?.name }}</span>
      </div>
    </ng-template>
  </p-select>
</div>